// extracted by mini-css-extract-plugin
export default {"Container":"TermsAndServices_Container__26dOj","Section":"TermsAndServices_Section__Aqr+G","Title":"TermsAndServices_Title__hDUXQ"};